export default __webpack_public_path__ + "static/media/erikasanchez.2ca06739.png";